import localization from '../locale/localization.json';
import {languageState} from '../redux/slices/app';
import {useAppSelector} from './redux';

export function useTranslation() {
  const language = useAppSelector(languageState);
  const t = (key: string) => {
    const translations: Record<string, any> =
      localization?.[language] || localization['tr'];
    return translations[key] || key;
  };

  return {t};
}
